import { render, staticRenderFns } from "./AlteracaoSegmentation.vue?vue&type=template&id=7607917a"
import script from "./AlteracaoSegmentation.vue?vue&type=script&lang=js"
export * from "./AlteracaoSegmentation.vue?vue&type=script&lang=js"
import style0 from "./AlteracaoSegmentation.vue?vue&type=style&index=0&id=7607917a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports